import Vue from 'vue';
// import Vuelidate from 'vuelidate';
import App from './App.vue';
import router from './router';

// import router_starter from "./starterRouter";
// import router from "./router/index"
import Argon from './plugins/argon-kit';
// import 'bootstrap'
import axios from 'axios';
import {store} from "./store/store";
import I18n from 'vue-i18n';
import vi from "./locale/vi.json";
import en from "./locale/en.json";

var VueCookie = require('vue-cookie');

Vue.prototype.$http = axios;

Vue.config.productionTip = false;
Vue.use(Argon, VueCookie);
// Vue.use(Vuelidate);
Vue.use(I18n);

const messages = {
  vi: vi,
  en: en,
}
const i18n = new I18n({
  locale: 'vi', // set locale
  messages,
  fallbackLocale: 'vi',
})

new Vue({
  router,
  store,
  i18n,
  render: h => h(App),
}).$mount('#app');

// Vue.component('test', {
//   template: '#template-input-data',
//   methods: {
//   },
// });



// WEBPACK FOOTER //
// ./src/main.js